import inRange from 'lodash/inRange';

const ranges = [
  {
    text: "Your strategic thinking skills are EXEMPLARY.  Read Cultivating the Strategic Mind for tangible ideas about how to further develop your strategic mind and remain a strong example for others.",
    start: 100,
    end: 125
  },
  {
    text: "Your strategic thinking skills are SOLID.  Read Cultivating the Strategic Mind for tangible ideas about how to further develop your strategic mind and become an even more potent role model for others.",
    start: 75,
    end: 100
  },
  {
    text: "Your strategic thinking skills are FOUNDATIONAL.  Read Cultivating the Strategic Mind for tangible ideas about how to acquire and exhibit a more strategic mind.",
    start: 50,
    end: 75
  },
  {
    text: "Your strategic thinking skills are AN OPPORTUNITY.  Read Cultivating the Strategic Mind for tangible ideas about how to begin develop a strategic mind.",
    start: 25,
    end: 50
  }
];

export default function getResultMessage(score) {
  return ranges
    .find(range => inRange(score, range.start, range.end))
    .text;
}



// WEBPACK FOOTER //
// ./src/getResultMessage.js